import {getSanityLocale} from './getSanityLocale';

type TranslationKey = string;

type TranslationObject = {
  [key: string]: string;
};

type Translations = {
  [key in TranslationKey]: TranslationObject;
};

const translations: Translations = {
  // Product Page
  ADD_TO_CART: {
    no: 'Legg i kurv',
    en: 'Add to cart',
  },
  BUY_NOW: {
    no: 'Kjøp nå',
    en: 'Buy now',
  },
  RELATED_PRODUCTS: {
    no: 'Lignende produkter',
    en: 'Related products',
  },
  DESCRIPTION: {
    no: 'Beskrivelse',
    en: 'Description',
  },
  MADE_TO_ORDER_BUTTON: {
    no: 'Forespør som made-to-order',
    en: 'Request as Made to Order',
  },

  // Product Card
  FROM: {
    no: 'Fra',
    en: 'From',
  },
  QUICK_ADD: {
    no: 'Quick add',
    en: 'Quick add',
  },
  NEWS: {
    no: 'Nyhet',
    en: 'News',
  },
  BOOK: {
    no: 'Bok',
    en: 'Book',
  },
  EXTENSION: {
    no: 'Mønstertillegg',
    en: 'Pattern extension',
  },

  // Difficulty
  DIFFICULTY: {
    no: 'Vaskelighet',
    en: 'Difficulty',
  },
  BEGINNER: {
    no: 'Nybegynner',
    en: 'Beginner',
  },
  INTERMEDIATE: {
    no: 'Trygg nybegynner',
    en: 'Advanced beginner',
  },
  ADVANCED: {
    no: 'Viderekommen',
    en: 'Intermediate',
  },
  EXPERT: {
    no: 'Avansert',
    en: 'Advanced',
  },

  // Size Chart
  SIZE_CHART_LABEL: {
    no: 'Kroppsmål i cm',
    en: 'Body measurements in cm',
  },

  TECHNIQUE: {
    no: 'Teknikker',
    en: 'Techniques',
  },
  MATERIAL: {
    no: 'Materialer',
    en: 'Materials',
  },
  COMPLEXITY: {
    no: 'Kompleksitet',
    en: 'Complexity',
  },

  // Made to Order
  MEASUREMENTS: {
    no: 'Legg inn mål',
    en: 'Enter measurements',
  },
  CHEST: {
    no: 'Bryst',
    en: 'Bust',
  },
  WAIST: {
    no: 'Midje',
    en: 'Waist',
  },
  HIPS: {
    no: 'Hofter',
    en: 'Hips',
  },

  CONTACT_LABEL: {
    no: 'Kontaktinformasjon',
    en: 'Contact details',
  },
  FULL_NAME: {
    no: 'Fullt navn',
    en: 'Full name',
  },
  EMAIL: {
    no: 'E-post',
    en: 'Email',
  },

  FABRIC_LABEL: {
    no: 'Har du ønsker til stoff- og fargevalg?',
    en: 'Do you have initial thoughts on fabric and colour choice?',
  },
  FABRIC_PLACEHOLDER: {
    no: 'Legg inn dine ønsker',
    en: 'Enter your preferences',
  },
  REQUEST_LABEL: {
    no: 'Har du andre spesifikke ønsker eller behov?',
    en: 'Do you have other specific requests or desires?',
  },
  REQUEST_PLACEHOLDER: {
    no: 'Legg inn dine ønsker',
    en: 'Enter your requests',
  },

  SEND_REQUEST: {
    no: 'Send forespørsel',
    en: 'Send request',
  },
  SEND_REQUEST_SUCCESS: {
    no: 'Forespørselen ble sendt',
    en: 'Your request was sent successfully',
  },
  SEND_REQUEST_LABEL: {
    no: 'Vi svarer deg så fort som mulig med flere detaljer om tilgjengelighet og prosess.',
    en: 'We will get back to you as soon as possible with details on availablity and process.',
  },

  // Cart
  CART: {
    no: 'Handlekurv',
    en: 'Cart',
  },
  SUBTOTAL: {
    no: 'Sum',
    en: 'Subtotal',
  },
  CHECKOUT: {
    no: 'Fullfør kjøp',
    en: 'Checkout',
  },
  CHECKOUT_MESSAGE: {
    no: 'Rabatt og frakt beregnes i kassen.',
    en: 'Taxes, shipping and discounts are calculated at checkout.',
  },
  EMPTY_CART: {
    no: 'Kurven er tom',
    en: 'Cart is empty',
  },
  CONTINUE_SHOPPING: {
    no: 'Fortsette å handle',
    en: 'Continue shopping',
  },

  // Navigation
  CLOSE: {
    no: 'Lukk',
    en: 'Close',
  },

  // Cookies
  ACCEPT: {
    no: 'Godta',
    en: 'Accept',
  },
};

export default function translate(key: TranslationKey): string {
  return translations[key][getSanityLocale()];
}
